import data from '../DataVaxiomPersonTitleSelect/data.json'

export function getValue(value) {
  return data.value.find(item => item.id === value)?.text || value
}
